import AppShell from "./components/Layout/AppShell";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SchoolSearch from "./page/School/Main/SchoolSearch";
import SchoolAuth from "./page/School/SchoolAuth";
import Login from "./page/Login";
import HomeAuth from "./page/HomeAuth";
import NotFound from "./page/Error/NotFound";
import UniversityMain from "./page/University/UniversityMain";
import SchoolSetting from "./page/School/Setting/SchoolSetting";
import SchoolDashboard from "./page/School/Dashboard/SchoolDashboard";
import SchoolSalesTotalView from "./page/School/Sales/SchoolSalesTotalView";
import VatBankPage from "page/School/Vat/VatBankPage";
import { Toaster } from "react-hot-toast";
import SchoolSalesMyView from "./page/School/Sales/SchoolSalesMyView";
import EstimatePage from "./page/Estimate/Estimate";
import { useEffect } from "react";
import { useAppDispatch } from "./store";
import { restoreSession } from "./store/userSlice";
import EstimateListPage from "./page/Estimate/EstimateList";

function AppContent() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    // 앱 시작 시 세션 복원
    dispatch(restoreSession());
  }, [dispatch]);

  return (
    <AppShell>
      <Routes>
        <Route path="/school/" element={<SchoolAuth />}>
          <Route path="search" element={<SchoolSearch />} />
          <Route path="sales" element={<SchoolSalesMyView />} />
          <Route path="estimate" element={<EstimateListPage />} />
          <Route path="sales-total" element={<SchoolSalesTotalView />} />
          <Route path="tax/*">
            <Route path="issue" element={<VatBankPage param="issue" />} />
            <Route path="apply" element={<VatBankPage param="apply" />} />
            <Route path="deposit" element={<VatBankPage param="deposit" />} />
          </Route>

          <Route path="" element={<SchoolDashboard />} />
        </Route>
        <Route path="/admin/" element={<SchoolAuth />}>
          <Route path="setting" element={<SchoolSetting />} />
        </Route>
        <Route path="/university/" element={<SchoolAuth />}>
          <Route path="" element={<UniversityMain />} />
        </Route>
        <Route path="/" element={<HomeAuth />} />
        <Route path="/login" element={<Login />} />
        <Route path="/estimate" element={<EstimatePage />} />
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </AppShell>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
      <Toaster
        position="top-left"
        containerStyle={{
          padding: "30px",
        }}
        toastOptions={{
          success: {
            style: {
              background: "#16a34a",
              color: "white",
            },
          },
          error: {
            style: {
              background: "#e11d48",
              color: "white",
            },
          },
        }}
      />
    </div>
  );
}

export default App;
